import styled, {css} from "styled-components";
import {BaseModal} from "./modalStyle";
import {patchStrategy} from "../strategy/strategyAction";
import React, {useState} from "react";
import {FunctionalModal} from "./FunctionalModal";
import {useDispatch} from "react-redux";
import ExitButton from "../buttons/ExitButton";
import {BlueButton} from "../buttons/ButtonStyles";
import {getCurrentDate2} from "../../utils/dateUtils";


const NextCodirModal =({id, setOpen}) => {
    const [newDate, setNewDate] = useState(null)
    const dispatch = useDispatch();
    const today = getCurrentDate2()
    const close = () => {
        setOpen(false);
    };

    const handleChange = (e) => {
        setNewDate(e.target.value)
    }
    const handleSubmit = async () => {
        if(newDate !== null){
            let data = {nextCodir: newDate}
            await dispatch(patchStrategy(id,data))
        }
        close();
    }
    return(
        <FunctionalModal
            setOpen={setOpen}
            component={
            <Modal>
                <ExitButton closeUpdate={close}/>
                <h2>Modifier la date du prochain CODIR</h2>
                <input onChange={handleChange} type="date" min={today}/>
                <Button onClick={handleSubmit}>Accepter</Button>

            </Modal>
        }
        />

        )
}
const Modal = styled(BaseModal)`
  align-items: center;
  width: 100vw;
  overflow-x: hidden;
  height: fit-content;
  gap: 1rem;
  position: unset;

  .tag-selected {
    background-color: #fafafa !important;
    border: 2px solid rgba(82, 215, 131, 1);
    color: rgba(33, 37, 41, 1);
  }

  @media (min-width: 768px) {
    width: 600px;
    ${(props) => {
    switch (props.$mode) {
        case true:
            return css`
            position: unset;
          `;
        default:
            return css`
            position: absolute;
          `;
    }
}}
  }
  
  button:first-of-type{
    align-self: flex-end;
  }
`

const Button = styled(BlueButton)`
  color: white;
  width: 15rem;
  padding: 0.3rem;
  justify-content: center;
  
  &:hover {
    svg{
      fill: var(--color-blue);
    }
    color:var(--color-blue) 
  }
`
export default NextCodirModal